<script>
import {Offcanvas} from "bootstrap";

export default {
    emits: ['onCanvasHidden'],
    props: {
        propId: String,
        propTitle: String,
        propContent: String,

        propShow: Boolean,
        propShown: Boolean,

        propPosition: String,
        propScroll: String,
        propBackdrop: String,
        propOpacity: String,
        propDark: Boolean,

        propCloseDisabled: Boolean,
        propHideCloseButton: Boolean,
    },
    watch: {
        propShow(newValue, oldValue) {
            this.trigger(newValue);
        },
    },
    methods: {
        trigger(show) {
            let elementCanvas = document.getElementById(this.propId);
            let canvasObj = Offcanvas.getOrCreateInstance(elementCanvas);

            if (show === true) {
                if (canvasObj !== null)
                    canvasObj.dispose();

                canvasObj = new Offcanvas(elementCanvas);
                elementCanvas.addEventListener('hidden.bs.offcanvas', event => {
                    this.$emit('onCanvasHidden');
                });

                canvasObj.show();
            } else {
                if (canvasObj !== null)
                    canvasObj.hide();
            }
        }
    },
    computed: {
        positionClass() {
            let position = this.propPosition;
            if (['top', 'start', 'bottom', 'end'].indexOf(this.propPosition) === -1)
                position = 'start';

            return `offcanvas-${position}`
        },
        opacityClass() {
            let opacity = this.propOpacity;
            if (['0', '25', '50', '75', '100'].indexOf(this.propOpacity) === -1)
                opacity = '100'
            return `opacity-${opacity}`;
        },
        darkClass() {
            if (this.propDark)
                return 'text-bg-dark';
            return '';
        },
        backdropValue() {
            if (['static', 'true', 'false'].indexOf(this.propBackdrop) === -1)
                return 'true';
            return this.propBackdrop
        },
        scrollValue() {
            if (['true', 'false'].indexOf(this.propScroll) === -1)
                return 'true';
            return this.propScroll
        }
    },
    mounted() {
        this.trigger(this.propShown);
    }
};
</script>
<template>
    <div class="offcanvas"
         tabindex="-1"
         :class="`${positionClass} ${opacityClass} ${darkClass}`"
         :data-bs-scroll="scrollValue"
         :data-bs-backdrop="this.backdropValue"
         :id="propId" :aria-labelledby="`${propId}Label`">
        <div class="offcanvas-header">
            <h4 class="offcanvas-title text-primary" :id="`${propId}Label`">{{ this.propTitle }}</h4>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"
                    :disabled="this.propCloseDisabled" v-if="!this.propHideCloseButton"></button>
        </div>
        <div class="offcanvas-body">
            <!-- Fixed content -->
            <span v-html="this.propContent" v-if="this.propContent"></span>
            <!-- Slot content -->
            <slot v-if="!this.propContent"></slot>
        </div>
    </div>
</template>